import React from "react";
import { useNavigate } from "react-router-dom";
// kendo
import { Loader } from "@progress/kendo-react-indicators";
// components
import DrTable from "../../../../components/drTable/dr_table";
import DrSecureDetailsStatusDialog from "../details/dr_secure_details_status_dialog";
// routes
import { DR_SECURE_INCIDENT_DETAILS } from "../../../../routes";

const DrSecureListBody = ({
  loading,
  records,
  onSortAction,
  openStatusDialog,
  onToggleDialog,
  incidentStatuses,
  currentIncidentStatus,
  onChangeIncidentStatus,
  onSaveIncidentStatus,
  showChangeStatusDialog,
  DeleteCall,
  showUpdateStatusButton,
}) => {
  const navigate = useNavigate();

  const handleActionDropdownClicked = (event, val) => {
    console.log("handleActionDropdownClicked event:", event);
    console.log("handleActionDropdownClicked val:", val);
    if (event.value === "Delete") {
      DeleteCall(val);
    } else {
      const { case_ref_no } = val.dataItem;
      const { status } = val.dataItem;
      if (event.value == "Update Status") {
        console.log("incident currentstatus-", case_ref_no, status);
        openStatusDialog(case_ref_no, status);
      } else {
        navigate(`${DR_SECURE_INCIDENT_DETAILS}?case_ref_no=${case_ref_no}`);
      }
    }
  };

  return (
    <React.Fragment>
      {loading ? (
        <Loader className="dr-secure-list-loader" type="infinite-spinner" />
      ) : (
        <DrTable
          data={records}
          actionDropdownClicked={handleActionDropdownClicked}
          onSortBy={onSortAction}
          showUpdateStatusOption={showUpdateStatusButton}
        />
      )}
      {showChangeStatusDialog && (
        <DrSecureDetailsStatusDialog
          onToggleDialog={onToggleDialog}
          incidentStatuses={incidentStatuses}
          currentIncidentStatus={currentIncidentStatus}
          onChangeIncidentStatus={onChangeIncidentStatus}
          onSaveIncidentStatus={onSaveIncidentStatus}
        />
      )}
    </React.Fragment>
  );
};

export default DrSecureListBody;
